/**
 * Shared bubble-graph panel surface (design_html `.map-panel`, bd
 * deepcontext-71j5): a visible near-white/elevated-dark surface distinct
 * from the lavender page canvas. `bg-canvas` made both ClustersGraph and
 * Top Mentions invisible against the page background they shared a colour
 * with — this is local styling, not a change to the global `--canvas` token
 * the rest of the app still relies on. One helper so both bubble graphs draw
 * the identical panel instead of two copies drifting apart.
 */
import {ChartMode} from './chartTheme';

export interface MapPanelStyle {
    background: string;
    border: string;
    boxShadow: string;
}

export function getMapPanelStyle(mode: ChartMode): MapPanelStyle {
    const isDark = mode === 'dark';
    return {
        background: isDark
            ? 'radial-gradient(120% 100% at 50% 0%, #2A2C33 0%, #26282E 60%, #212226 100%)'
            : 'radial-gradient(120% 100% at 50% 0%, #FFFFFF 0%, #FAF9FC 60%, #F4F2F8 100%)',
        border: `1px solid ${isDark ? '#33363D' : '#E6E2F0'}`,
        boxShadow: isDark
            ? '0 1px 2px rgba(0,0,0,.30), 0 8px 24px rgba(0,0,0,.35)'
            : '0 1px 2px rgba(60,50,100,.05), 0 8px 24px rgba(60,50,100,.06)',
    };
}
